import axios from 'axios'
import qs from 'qs'
import { HTTP_401_ERROR, TOKEN_KEY } from 'Constants'

const { REACT_APP_BASE_API: baseURL } = process.env

const paramsSerializer = params => qs.stringify(params,
  { arrayFormat: 'brackets' })

const requestAuthInterceptor = config => {
  const token = JSON.parse(localStorage.getItem(TOKEN_KEY))
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return Promise.resolve(config)
}

function invalidLoginOrPasswordMessage (error) {
  return error?.response?.data?.message === 'Invalid login or password'
}

const responseUnauthorizedInterceptor = error => {
  if (error.response && (error.response.status === HTTP_401_ERROR &&
    !invalidLoginOrPasswordMessage(error))) {
    setTimeout(() => {
      localStorage.setItem(TOKEN_KEY, null)
      window.location.reload()
    }, 3000)
  }
  return Promise.reject(error)
}

const responseDataInterceptor = response => response.data

const api = axios.create({ baseURL, paramsSerializer })

api.interceptors.request.use(requestAuthInterceptor)
api.interceptors.response.use(undefined, responseUnauthorizedInterceptor)
api.interceptors.response.use(responseDataInterceptor)

const apiFullResponse = axios.create({ baseURL, paramsSerializer })

apiFullResponse.interceptors.request.use(requestAuthInterceptor)
apiFullResponse.interceptors.response.use(undefined,
  responseUnauthorizedInterceptor)

export { apiFullResponse }

export default api
